"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DraggableListStyled = exports.DraggableListItemContentStyled = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Layout = require("../../atoms/Layout");

var DraggableListItemContentStyled = (0, _styledComponents.default)(_Layout.Box).attrs(function (props) {
  return {
    style: {
      top: "".concat(props.top, "px"),
      transition: props.isDragged ? 'none' : 'all 500ms',
      cursor: props.isDragged || props.isSelected ? 'grabbing' : 'grab',
      height: "".concat(props.height, "px")
    }
  };
}).withConfig({
  displayName: "styles__DraggableListItemContentStyled",
  componentId: "sc-1hyv93o-0"
})(["user-select:none;position:absolute;"]);
exports.DraggableListItemContentStyled = DraggableListItemContentStyled;
var DraggableListStyled = (0, _styledComponents.default)(_Layout.Box).withConfig({
  displayName: "styles__DraggableListStyled",
  componentId: "sc-1hyv93o-1"
})({
  position: 'relative',
  borderWidth: 1,
  borderStyle: 'solid',
  touchAction: 'none',
  userSelect: 'none',
  backgrounColor: 'red',
  overflowY: 'auto',
  overflowX: 'hidden'
});
exports.DraggableListStyled = DraggableListStyled;